import { render } from "./TransactionsView.vue?vue&type=template&id=01acf8d4"
import script from "./TransactionsView.vue?vue&type=script&lang=js"
export * from "./TransactionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/TransactionsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01acf8d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01acf8d4', __exports__)) {
    api.reload('01acf8d4', __exports__)
  }
  
  module.hot.accept("./TransactionsView.vue?vue&type=template&id=01acf8d4", () => {
    api.rerender('01acf8d4', render)
  })

}


export default __exports__